import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.MENU_LIST_SUCCESS, data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.MENU_LIST_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const menuList = (params) => {
  return async (dispatch) => {
    dispatch({ type: CONST.MENU_LIST_REQUEST });

    axios.get('/menus', { params }).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
